import { useTheme, useMediaQuery } from '@mui/material'
import { isOpenedInWebview } from '@e3dc-react/shell/Libs/webview'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'

/**
 * Determines if the app should behave in "webview mode".
 * True when:
 * - Actually opened inside the React Native webview, OR
 * - Feature flag `shouldSimulateMobileAppOnWebview` is enabled AND viewport is sm or below
 */
const useIsWebviewMode = (): boolean => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const {
    featureFlags: { shouldSimulateMobileAppOnWebview },
    isFeatureFlagsLoading,
  } = useFeatureFlagsContext()
  const simulateMobileAppInWebView = Boolean(isSmallScreen && !isFeatureFlagsLoading && shouldSimulateMobileAppOnWebview)

  return isOpenedInWebview() || simulateMobileAppInWebView
}

export default useIsWebviewMode
